import { Component, OnInit, HostListener } from '@angular/core';
import { DuplicateJobInputDocument } from 'src/app/models/job';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { ToastrService } from 'ngx-toastr';
import { OcrJob, OcrChannel, HttpStatus } from 'src/app/constants/constants';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigurationPage } from '../ConfigurationPage';

@Component({
  selector: 'app-duplicate-job',
  standalone: false,
  templateUrl: './duplicate-job.component.html',
  styleUrls: ['./duplicate-job.component.scss']
})
export class DuplicateJobComponent implements OnInit, ConfigurationPage {

  currentInputDocument: DuplicateJobInputDocument;
  isloading = false;
  pdfWidth: number = null;

  constructor(private apiHandler: ApiService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  getNextFile() {
    this.isloading = true;
    const request = this.apiHandler.getABCisRequest<DuplicateJobInputDocument>
    (ABCisApi.Ocr, `job/${OcrJob.DUPLICATE_TO_BE_CONFIRMED}/next-document?channelId=${OcrChannel.WEB_UI}`);
    request.then((httpResponse) => {
      if (httpResponse.status == HttpStatus.NO_CONTENT) {
        this.currentInputDocument = undefined;
        this.toastr.info('No more files available for Duplicate job');
      } else {
        this.currentInputDocument = httpResponse.body;
      }
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  @HostListener('window:beforeunload', ['$event'])
  OnClose($event) {
    if(this.currentInputDocument !== undefined) $event.returnValue = 'Are you sure you want to leave?';
  }

  /**
   * This gets called when routing away from page
   */
  ReleaseDocument() {
    this.releaseFile();
  }

  releaseFile() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/release`);
    request.then((val) => {
      this.currentInputDocument = undefined;
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  onDuplicateClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/confirm-duplicate`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  changePdfWidth(num) {
    this.pdfWidth = num;
  }

  onRestoreClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/redo-category-in-web`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  onAllocateClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/to-allocator`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }
}
